import { createContext, Dispatch, ReactNode, useContext, useReducer } from 'react';
import { IPageStatus } from './config/IPageStatus';
import React from 'react';

export interface ProductState {
    pageStatus: IPageStatus;
    activeTab: string;
    productMsg: any; // 对象，key为generalKey，value为productMsg对象
    productSupport: any; // 对象，key为generalKey，value为productSupport对象
    productSpecs: any[]; // 数组，每个元素为productSpec对象
}

type ProductAction = {
    type: string;
    payload: any;
};

const initState: ProductState = {
    pageStatus: IPageStatus.LAUNCH,
    activeTab: 'Product',
    productMsg: null,
    productSupport: null,
    productSpecs: [],
};

const fsReducer = (state: ProductState, action: ProductAction): ProductState => {
    const { type, payload } = action;
    switch (type) {
        case 'changePageStatus':
            return { ...state, pageStatus: payload };
        case 'changeProductTab':
            return { ...state, activeTab: payload };
        case 'changeProductMsg':
            return { ...state, productMsg: payload };
        case 'changeProductSupport':
            return { ...state, productSupport: payload };
        case 'changeProductSpec':
            return { ...state, productSpecs: payload };
        default:
            return state;
    }
};

export const ProductContext = createContext<{ state: ProductState; dispatch: Dispatch<ProductAction> }>({
    state: initState,
    dispatch: () => null,
});

export function ProductProvider({ children, pageStatus }: { children: ReactNode; pageStatus: IPageStatus }) {
    const [state, dispatch] = useReducer(fsReducer, { ...initState, pageStatus });
    return React.createElement(ProductContext.Provider, {
        value: { state, dispatch },
        children,
    });
}

export const useProduct = () => {
    const context = useContext(ProductContext);
    return context;
};

export const useProductState = () => {
    const { state } = useProduct();
    return state;
};

export const useProductDispatch = () => {
    const { dispatch } = useProduct();
    return dispatch;
};

export const useProductActiveTab = () => {
    const { state } = useProduct();
    return state.activeTab;
};

export const useProductPageStatus = () => {
    const { state } = useProduct();
    return state.pageStatus;
};

export const useProductMsg = () => {
    const { state } = useProduct();
    return state.productMsg;
};

export const useProductSupport = () => {
    const { state } = useProduct();
    return state.productSupport;
};

export const useProductSpec = () => {
    const { state } = useProduct();
    return state.productSpecs;
};
